import { render, staticRenderFns } from "./lift-refer-request.vue?vue&type=template&id=66f29dd9&"
import script from "./lift-refer-request.vue?vue&type=script&lang=js&"
export * from "./lift-refer-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports